import { render, staticRenderFns } from "./TypeServiceForm.vue?vue&type=template&id=3094de5a&"
import script from "./TypeServiceForm.vue?vue&type=script&lang=js&"
export * from "./TypeServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports